import { Modal } from 'antd';
import styled from 'styled-components';

import { horizontalAttributesFormStyles } from 'components/damages/EditableDamageAttributes/AttributesForm.style';

export const StyledModal = styled(Modal)`
  .ant-modal-body {
    max-height: 70vh;
    overflow-y: auto;
  }

  /* Neutralize AttributesForm's nested scroll so the body scrolls as one. */
  .ant-modal-body > div:has(> form),
  .ant-modal-body form,
  .ant-modal-body .form-fields-container {
    height: auto;
    max-height: none;
    overflow: visible;
  }

  .ant-modal-body .ant-form-item {
    margin-bottom: 8px;
  }

  .ant-modal-body {
    ${horizontalAttributesFormStyles}
  }

  .ant-modal-body .form-fields-container + * {
    display: none;
  }

  .ant-modal-footer .ant-btn + .ant-btn {
    margin-left: 8px;
  }
`;
